"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeedbackEventName;
(function (FeedbackEventName) {
    FeedbackEventName["RENDERED"] = "ya:feedback:survey:rendered";
    FeedbackEventName["SYNC"] = "ya:feedback:survey:sync";
    FeedbackEventName["SKIP"] = "ya:feedback:survey:skip";
    FeedbackEventName["FINISHED"] = "ya:feedback:survey:finished";
    FeedbackEventName["SUITABLE"] = "ya:feedback:suitable";
})(FeedbackEventName || (FeedbackEventName = {}));
//# sourceMappingURL=types.js.map